import { Box, Typography } from "@mui/material";
import Layout from "../../../layouts";
import { ApiKeysTable } from "./_components/ApiKeysTable";
import { useEffect } from "react";
import { useExternalApiKeyStore } from "../../../contexts/useExternalApiKeyStore";
import CustomModal from "../../../components/modal/CustomModal";
import { useTranslation } from "react-i18next";
import { common } from "../../../i18n";
import { CreateApiKey } from "./_components/CreateApiKey";
import { isApiKeysOpen } from "../../../config/config";
import { useNavigate } from "react-router-dom";

export const ApiKeysPage = () => {
  const { t } = useTranslation([common], { nsMode: "fallback" });

  const { fetchKeys, openModal, setOpenModal, fetchServices } =
    useExternalApiKeyStore();

  useEffect(() => {
    fetchKeys();
    fetchServices();
  }, [fetchKeys, fetchServices]);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isApiKeysOpen)
      navigate("/overview/total-emissions", { replace: true });
  }, [isApiKeysOpen]);

  return (
    <Layout>
      <Box
        display={"flex"}
        flexDirection={"column"}
        width={"100%"}
        height={"100%"}
        flexGrow={1}
        bgcolor={"var(--white)"}
        sx={{ minHeight: 0 }} // กัน flex ลูก overflow
      >
        <Box flex={1} p="40px" sx={{ minHeight: 0 }}>
          <ApiKeysTable />
        </Box>

        <CustomModal
          header={
            <Typography variant="h3" color={"var(--dark)"}>
              {t("Create-API-Key")}
            </Typography>
          }
          body={<CreateApiKey />}
          open={openModal}
          onClose={() => setOpenModal()}
        />
      </Box>
    </Layout>
  );
};
